import { createStore } from 'vuex'

// npm i --save-dev @types/js-cookie
import Cookies from "js-cookie";

/**
 * 注释：sessionStorage 用于临时保存同一窗口(或标签页)的数据，在关闭窗口或标签页之后将会删除这些数据。
 */
declare let SessionStorage: any;
//const COOKIES: any = Cookies

const USER = "USER";
const USER_ID = "USER_ID_BLOG";
const USER_NAME = "USER_NAME_BLOG";
const USER_LOGIN_NAME = "USER_LOGIN_NAME_BLOG";
const USER_TOKEN = "USER_TOKEN_BLOG";

const store = createStore({
  state: {
    //user: SessionStorage.get(USER) || {}
    user: {
      id: Cookies.get(USER_ID) == 'undefined' ? undefined : Cookies.get(USER_ID),
      name: Cookies.get(USER_NAME) == 'undefined' ? undefined : Cookies.get(USER_NAME),
      token: Cookies.get(USER_TOKEN) == 'undefined' ? undefined : Cookies.get(USER_TOKEN),
      loginName: Cookies.get(USER_LOGIN_NAME) == 'undefined' ? undefined : Cookies.get(USER_LOGIN_NAME),
    }
  },
  mutations: {
    setUser(state, user) {
      console.log("store user：", user);
      state.user = user;
      //SessionStorage.set(USER, user);
      //设置cookie，有效期为8小时
      const expire = { expires: 8 / (24) };
      Cookies.set(USER_ID, user.id, expire);
      Cookies.set(USER_NAME, user.name, expire);
      Cookies.set(USER_LOGIN_NAME, user.loginName, expire);
      Cookies.set(USER_TOKEN, user.token, expire);
      getUser()
    },
    removeUser(state, user) {
      // 删除指定名称的Cookie
      Cookies.remove(USER_ID)
      Cookies.remove(USER_NAME)
      Cookies.remove(USER_LOGIN_NAME)
      Cookies.remove(USER_TOKEN)
      getUser()
    }
  },
  actions: {
  },
  modules: {
  }
});

const getUser = () => {
  const user_id = Cookies.get(USER_ID);
  const user_name = Cookies.get(USER_NAME);
  const user_loginName = Cookies.get(USER_LOGIN_NAME);
  const user_token = Cookies.get(USER_TOKEN);
  console.log('id: ', user_id)
  console.log('name: ', user_name)
  console.log('loginName: ', user_loginName)
  console.log('token: ', user_token)
};

const filter = (obj: any) => {
  if (obj == undefined || obj == '' || obj == 'undefined') {
    return undefined
  }
  return obj
}

export default store;
